import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import * as Tab from '../../util/TabValue';
import RenderTabs from '../misc/Tabs';
import ModuleStatus from './ModuleStatus';
import ModuleInstanceRun from './ModuleInstanceRun';
import ModuleView from './ModuleView';
import ModulePeriods from './modulePeriods/ModulePeriods';
import { getModuleBasicInfo, resetModuleBasicInfo } from '../../store/ModuleAction';
import { useTranslation } from 'react-i18next';
import OneRosterCombineTeam from './components/modules/components/OneRosterExport/OneRosterCombineTeam';
import { CoreModule } from '../../models/CoreModels';
import { RequestState } from '../../models/RequestState';
import { RootState } from '../../store/store';
import StatusCode from '../../util/StatusCode';
import Loading from '../misc/Loading';
import NotFound from '../administration/components/NotFound';


const Configuration = () => {
    const { moduleId } = useParams();
    const dispatch = useDispatch();
    const module = useSelector<RootState, RequestState<CoreModule>>(state => state.module.moduleBasicInfo);

    const { t } = useTranslation('configuration');

    useEffect(() => {
        if (moduleId) {
            getModuleBasicInfo(moduleId)(dispatch);
        }
        return () => {
            resetModuleBasicInfo()(dispatch);
        }
    }, [dispatch, moduleId]);

    let tabs = [];

    if (!moduleId) {
        return;
    };

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/module">{t('configuration.heading')}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (module.code) {
        case StatusCode.COMPLETE:
            if (module.data?.runnable) {
                tabs.push(Tab.Tabs.Status);
                tabs.push(Tab.Tabs.ModuleInstanceRun);
            }
            tabs.push(Tab.Tabs.Configuration)
            tabs.push(Tab.Tabs.Periods)
            if (module.data?.moduleTypeName === "OneRosterConfiguration") {
                tabs.push(Tab.Tabs.CombineTeams)
            }

            displayName = module.data?.title ? ' / ' + module.data.title : '';

            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    url="module"
                    id={moduleId} />
                <div className="tab-border" />

                <Routes>
                    <Route path={Tab.Tabs.Status.url} element={<ModuleStatus />} />
                    <Route path={Tab.Tabs.ModuleInstanceRun.url} element={<ModuleInstanceRun />} />
                    <Route path={Tab.Tabs.Configuration.url} element={<ModuleView />} />
                    <Route path={Tab.Tabs.Periods.url} element={<ModulePeriods />} />
                    <Route path={Tab.Tabs.CombineTeams.url} element={<OneRosterCombineTeam />} />
                    <Route path="*" element={<Navigate replace={true} to={`/module/${moduleId}/${Tab.Tabs.Status.url}`} />} />
                </Routes>
            </>))

        case StatusCode.ERROR:
            if (module?.error?.response?.status === 400 || module?.error?.response?.status === 404) {
                return (
                    <NotFound
                        header={t('configuration.heading')}
                        translateKey={{ i18nKey: "configuration.moduleNotFound", ns: "configuration" }}
                        link="/module"
                    />
                );
            } else {
                return renderContent(<p>{module.error.response?.statusText}</p >);
            }

        default:
            return (renderContent(<Loading />));
    }
}

export default Configuration;
